import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import Config from "../../Config";
import { color_red_default } from "../../constants/colors";
import { InfinitySpin } from "react-loader-spinner";
import { v4 as uuidv4 } from 'uuid';
import { OnestBoldDefault, OnestNormalBig, OnestNormalDefault, OnestSemiBoldBig } from "../styled/TextComponents";
import { Button } from "../controls/Button/Button";
import { ButtonDefault } from "../controls/Button/ButtonDefault";
import { useI18n } from "../../i18n/I18nProvider";

export const RedirectToLoginIfNotAuthenticated = ({ children }) => {
    const { t } = useI18n();
    const navigate = useNavigate();
    const [checked, setChecked] = useState(false);
    const [isLimited, setIsLimited] = useState(false);

    useEffect(() => {
        const run = async () => {
            const jwt = Cookies.get('jwt');
            if (!jwt) {
                return navigate("/auth/login");
            }

            let uid = await localStorage.getItem("uid");
            if (!uid) {
                uid = uuidv4();
                await localStorage.setItem("uid", uid);
            }

            try {
                const res = await axios.get(Config.BACKEND_ADDR + "/auth/token_auth", { params: { token: jwt } });
                if (res.status !== 200) {
                    navigate("/auth/login");
                    setChecked(true);
                    return;
                }
            } catch (err) {
                console.error("Can't authenticate. Err: ", err);
                navigate("/auth/login");
                setChecked(true);
                return;
            }

            try {
                const checkSessionResponse = await axios.get(Config.BACKEND_ADDR + "/devices/is_actual/" + uid);
                if (checkSessionResponse.status !== 200) {
                    Cookies.remove('jwt');
                    setIsLimited(true);
                    setChecked(true);
                    return;
                }
                setChecked(true);
            } catch (err) {
                if (err.response && err.response.status === 404) {
                    Cookies.remove('jwt');
                    setIsLimited(true);
                } else {
                    console.error("Error checking session:", err);
                }
                setChecked(true);
            }
        };

        run();
    }, [navigate]);

    return (
        <>{checked ? 
            (isLimited ? 
                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    height: '100vh', 
                    width: '100vw',
                    gap: 20 }}>
                    <div style={{ 
                        width: 280, 
                        display: 'flex', 
                        alignItems: 'center',
                        textAlign: 'center',
                        justifyContent: 'center'
                    }}>
                   <OnestSemiBoldBig style={{ padding: '4px' }}>{t("Достигнут лимит в 2 устройства")} </OnestSemiBoldBig>
                   </div>
                   <OnestNormalDefault style={{ padding: '4px 40px' }}>{t("Текущая сессия завершена автоматически")}</OnestNormalDefault>
                   <ButtonDefault 
                        onClick={() => navigate("/auth/login")}
                        width={ window.innerWidth > 420 ? 360 : window.innerWidth - 60}
                        height={42}
                    >{t("Вернуться ко входу")}</ButtonDefault>
                </div>
                : children) 
            : <InfinitySpin visible={true} width={200} color={color_red_default} />}</>
    )
}